import { appendLocaleSources } from '../../hooks/useTranslate'
import NoticesPresents from '../../api/notciesPresents'

appendLocaleSources({
  [NoticesPresents.urn]: {
    page: {
      title: 'Уведомления',
    },
    modal: {
      title: {
        create: 'Создать опцию',
        update: 'Обновить опцию',
      },
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить эту опцию?`,
    },
  },
}, 'ru')

appendLocaleSources({
  [NoticesPresents.urn]: {
    page: {
      title: 'Notifications',
    },
    modal: {
      title: {
        create: 'Create Option',
        update: 'Update Option',
      },
    },
    message: {
      confirmDelete: `Are you sure you want to delete this option?`,
    },
  },
}, 'en')

appendLocaleSources({
  [NoticesPresents.urn]: {
    page: {
      title: 'Bildirishnomalar',
    },
    modal: {
      title: {
        create: 'Tanlovni yaratish',
        update: 'Tanlovni yangilash',
      },
    },
    message: {
      confirmDelete: `Siz haqiqatan ham ushbu tanlovni o‘chirmoqchimisiz?`,
    },
  },
}, 'uz')

